import { z } from 'zod';
// One ENABLED platform identity provider as the login screen needs it — pre-auth,
// minimal, no secrets (ADR-003 §Federated identity · ADR-053). Returned by login
// discovery (below) to drive the auto-redirect / same-domain picker. There is no
// public "list all providers" surface — anonymous visitors never enumerate which
// orgs are onboarded; a provider is revealed only to someone who typed a matching
// email domain.
export const SsoProviderSchema = z
    .object({
    id: z.string().max(16),
    display_name: z.string().max(64),
})
    .strict();
// ── identifier-first login discovery (Home Realm Discovery) ──────────────────
// The login screen is one "email or username" field. The client POSTs what was
// typed; the server resolves HOW to sign in. POST (not a query string) keeps the
// typed identifier out of access logs + browser history.
//
// Resolution is by email DOMAIN only and STATELESS w.r.t. account existence: it
// reveals whether a *domain* is SSO-configured (an org-level fact), never whether
// a *person* has an account here (SECURITY §Resource-enumeration defense). A
// username, or an email whose domain has no enabled connection, → mode='password'
// regardless of whether that account exists.
export const DiscoverRequestSchema = z
    .object({ identifier: z.string().trim().min(1).max(255) })
    .strict();
// mode='sso' → route to the IdP; `providers` has ≥1 (exactly 1 = auto-redirect,
// >1 = a same-domain picker — the rare ADFS↔Entra migration case, ADR-054 §B).
// mode='password' → reveal the local password field; `providers` is empty.
export const DiscoverResponseSchema = z
    .object({
    mode: z.enum(['sso', 'password']),
    providers: z.array(SsoProviderSchema),
})
    .strict();
